// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-wrapper img[data-v-94724e3a]{max-height:86px;margin:0}.contrast footer.page-footer[data-v-94724e3a]{background:#000!important;color:#fff!important;border-top:1px solid #fff}.page-footer[data-v-94724e3a]{padding:10px}.footer-copyright[data-v-94724e3a]{min-height:30px;padding:0;font-size:85%}#footer-copyright[data-v-94724e3a]{margin:0}", ""]);
// Exports
module.exports = exports;
